import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Popconfirm,
  message,
  Row,
  Col,
  Statistic,
  Tag,
  Tabs,
  DatePicker,
  Upload,
  Switch,
  Divider,
  Badge,
  Typography,
  Drawer,
} from "antd";
import {
  ShoppingCartOutlined,
  AppstoreOutlined,
  TagsOutlined,
  GiftOutlined,
  DashboardOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  UploadOutlined,
  DollarOutlined,
  ShoppingOutlined,
  UserOutlined,
  BarChartOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import DashboardReports from "./pages/DashboardReports";
import ProductsSection from "./pages/ProductsSection";
import CategoriesSection from "./pages/CategoriesSection";
import DiscountsSection from "./pages/DiscountsSection";
import OrdersSection from "./pages/OrdersSection";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import UserPage from "./pages/UserList";
import BannerManagement from "./pages/BannerSection";
import Settings from "./pages/Settings";

const { Header, Sider, Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const EcommerceDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("dashboard");
  const { logout } = useAuth();
  const navigation = useNavigate();
  const renderContent = () => {
    switch (selectedMenu) {
      case "dashboard":
        return <DashboardReports />;
      case "products":
        return <ProductsSection />;
      case "categories":
        return <CategoriesSection />;
      case "discounts":
        return <DiscountsSection />;
      case "orders":
        return <OrdersSection />;
      case "users":
        return <UserPage />;
      case "banner":
        return <BannerManagement />;
      case "settings":
        return <Settings />;

      // case 'logout':
      //   return ()=>{
      //     logout()
      //     navigation('/login')
      //   };
      default:
        return <DashboardReports />;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          style={{
            height: 32,
            margin: 16,
            background: "rgba(255, 255, 255, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontWeight: "bold",
          }}
        >
          {collapsed ? "E" : "E-Commerce"}
        </div>
        <Menu
          theme="dark"
          selectedKeys={[selectedMenu]}
          mode="inline"
          onClick={({ key }) => setSelectedMenu(key)}
        >
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            Dashboard
          </Menu.Item>
          <Menu.Item key="products" icon={<ShoppingOutlined />}>
            Products
          </Menu.Item>
          <Menu.Item key="categories" icon={<AppstoreOutlined />}>
            Categories
          </Menu.Item>
          <Menu.Item key="discounts" icon={<GiftOutlined />}>
            Discounts
          </Menu.Item>
          <Menu.Item key="orders" icon={<ShoppingCartOutlined />}>
            Orders
          </Menu.Item>
          <Menu.Item key="users" icon={<ShoppingCartOutlined />}>
            Users
          </Menu.Item>
          <Menu.Item key="banner" icon={<ShoppingCartOutlined />}>
            Banner
          </Menu.Item>
          <Menu.Item key="settings" icon={<ShoppingCartOutlined />}>
            Settings
          </Menu.Item>

          {/* <Menu.Item key="logout" icon={<ShoppingCartOutlined />}>
            Logout --{">"}
          </Menu.Item> */}
        </Menu>
      </Sider>
      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: "0 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Title level={4} style={{ margin: 0 }}>
            E-Commerce Admin Dashboard
          </Title>
          <Space>
            <Button
              onClick={() => {
                logout();
                navigation("/login");
              }}
              type="text"
              icon={<LogoutOutlined />}
            >
              Logout
            </Button>

            <Button type="text" icon={<UserOutlined />}>
              Admin
            </Button>
          </Space>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            background: "#f0f2f5",
            padding: 24,
            borderRadius: 8,
          }}
        >
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default EcommerceDashboard;
